import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss'],
})
export class MembersComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  members;
  filteredMembers;
  currentUser;
  locked = false;
  params = null;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.analyticsService.event('member_view');
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
          this.locked = false;
        } else {
          this.locked = true;
        }
      })
    );
    this.subscriptions.add(
      this.userService.getMembers().subscribe((membersRes) => {
        this.members = membersRes.filter(member => !member.banned);
        this.members.forEach((m) => {
          if (m.institutions === null || m.events === null || m.projects === null) {
            this.userService.deleteUser(m.uid);
          }
        });
        this.filteredMembers = this.members;
      })
    );

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  filterChange(f) {
    this.filteredMembers = f.filteredList;
  }
}
